var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewInvoice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4,18.6h23c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1h-23c-1.7,0-3.1,1.4-3.1,3.1C21.3,17.2,22.7,18.6,24.4,18.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4,35.4h-46c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1h46c1.7,0,3.1-1.4,3.1-3.1C73.5,36.8,72.1,35.4,70.4,35.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4,44.9h-46c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1h46c1.7,0,3.1-1.4,3.1-3.1C73.5,46.3,72.1,44.9,70.4,44.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9,58.4H23.4c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1h12.5c1.7,0,3.1-1.4,3.1-3.1C39,59.8,37.6,58.4,35.9,58.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9,68.9L35.9,68.9H24.4c-1.7,0-3.1,1.4-3.1,3.1s1.4,3.1,3.1,3.1l0,0h11.5c1.7,0,3.1-1.4,3.1-3.1S37.6,68.9,35.9,68.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9,79.4H23.4c-1.7,0-3.1,1.4-3.1,3.1s1.4,3.1,3.1,3.1h12.5c1.7,0,3.1-1.4,3.1-3.1S37.6,79.4,35.9,79.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85,53V27c0-0.2,0-0.4-0.1-0.6l0,0l0,0c-0.1-0.3-0.1-0.5-0.3-0.7c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.2-0.3-0.5-0.5-0.7l-23-23 c-0.2-0.2-0.4-0.3-0.6-0.5c-0.1,0-0.1-0.1-0.2-0.1C60,1.1,59.8,1,59.5,1l0,0c-0.2,0-0.4-0.1-0.6-0.1H25.2c-8.5,0-15.3,6.9-15.3,15.3 v67.5c0,8.5,6.9,15.3,15.3,15.3h44.5C78.2,99,85,92.1,85,83.7h-6.1c0,5.1-4.1,9.2-9.2,9.2H25.2c-5.1,0-9.2-4.1-9.2-9.2V16.3 c0-5.1,4.1-9.2,9.2-9.2h30.7v7.7c0,8.5,6.9,15.3,15.3,15.3h7.7V53H85z M62,11.4l12.5,12.5h-3.3c-5.1,0-9.2-4.1-9.2-9.2 C62,14.7,62,11.4,62,11.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M90,67.5L90,67.5c-3.1-7.4-11.2-12.6-19.9-12.6c-8.6,0-16.8,5.2-19.9,12.6c-0.2,0.6-0.2,1.2,0,1.9 C53.3,76.8,61.5,82,70.1,82c8.6,0,16.8-5.2,19.9-12.6C90.2,68.8,90.2,68.1,90,67.5z M70.1,77.1c-6.3,0-12.4-3.6-14.9-8.7 c2.6-5.1,8.8-8.7,14.9-8.7c6.2,0,12.5,3.6,15,8.7C82.6,73.5,76.4,77.1,70.1,77.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1,61.2c-4,0-7.3,3.3-7.3,7.3s3.3,7.3,7.3,7.3c4.1,0,7.3-3.2,7.3-7.3C77.4,64.5,74.1,61.2,70.1,61.2z M70.1,70.9 c-1.3,0-2.4-1.1-2.4-2.4s1.1-2.4,2.4-2.4s2.4,1.1,2.4,2.4S71.4,70.9,70.1,70.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewInvoice);
export default __webpack_public_path__ + "static/media/view-invoice.78add3534885dde95beba5b096c5cdf9.svg";
export { ForwardRef as ReactComponent };